"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const MapConsentWrapper = styled_components_1.default.div `
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    background-color: #fff;
    max-width: 500px;
    display: flex;
    flex-direction: column;

    height: 65%;
    color: #000;
    overflow: scroll;
    padding: 10px;
    margin: 10px;

    h3 {
      margin: 10px 0px;
    }

    .bulk-text {
      overflow: scroll;
      font-size: 12px;
    }

    strong {
      font-weight: 800;
    }

    a {
      text-decoration: underline !important;
    }

    .small-text {
      font-size: 10px;
    }

    .MuiFormControlLabel-label {
      font-size: 10px;
    }

    .MuiCheckbox-root {
      padding-right: 2px;
    }
  }
`;
const miniDictionary = {
    title: {
        en: "We need your consent",
        de: "Wir brauchen Ihre Einwilligung",
    },
    disclaimerText: {
        en: `<p>This map material is provided by Google*. If you load the
             Google Map, your data - including your IP address - is transmitted
             to Google and may be stored and processed by Google inter alia in
             the USA. We have no influence over further data processing by Google.
             </br>
             By clicking on "Accept", you consent to the
             <strong>transmission of data to Google</strong> for this Google Map
             in accordance with Art. 6 (1) (a) GDPR and at the same time
             explicitly consent to the
             <strong> transfer of data to the USA </strong> in accordance with
             Art. 49 (1) (a) GDPR. If you no longer wish to consent to each
             Google Map individually in the future and wish to be able to load
             the maps without this blocker, you can also select "Always accept
             Google Maps" and thereby consent to the associated data
             transmissions and transfers to Google and to the USA for all
             other Google Maps which you open on our website in the future.
             Please note that, in the opinion of the European Court of Justice,
             there does not currently exist an adequate level of data
             protection in line with EU standards in the USA, and at present
             we cannot provide appropriate safeguards to protect your data and
             offset this shortcoming.</p>

             <p>
             <strong>Possible risks </strong> to you of data transfer
             to the USA are that
             <strong>access by state authorities</strong>
             cannot be excluded and that your data could be processed for
             reasons of national security, law enforcement or for other
             purposes in the public interest of the USA, possibly without you
             being informed separately and without enforceable rights and
             effective legal remedies being available to you.
             </p>
             `,
        de: `<p>Dieses Kartenmaterial wird
             von Google* bereitgestellt. Wenn Sie die Google-Karte laden,
             werden Ihre Daten, darunter Ihre IP-Adresse, an Google
             übermittelt und können von Google u.a. in den USA gespeichert
             und verarbeitet werden. Auf die weitere Datenverarbeitung
             durch Google haben wir keinen Einfluss.
             </br>
             Indem Sie auf „Akzeptieren“ klicken, willigen Sie für diese
             Google-Karte gemäß Art. 6 Abs. 1 lit. a DSGVO in die
             <strong>Datenübermittlung an Google</strong> und zugleich ausdrücklich
             gemäß Art. 49 Abs. 1 lit. a DSGVO in die
             <strong>Datenübermittlung in die USA</strong> ein.
             Wenn Sie künftig nicht mehr zu jeder Google-Karte einzeln einwilligen
             und diese ohne diesen Blocker laden können möchten, können Sie
             zusätzlich „Google Maps immer akzeptieren“ auswählen und damit
             auch für alle weiteren Google-Karten, welche Sie zukünftig auf
             unserer Website noch aufrufen werden, in die damit verbundenen
             Datenübermittlungen an Google und in die USA einwilligen.
             Beachten Sie, dass nach Einschätzung des Europäischen Gerichtshofs
             in den USA derzeit kein nach EU-Standards angemessenes
             Datenschutzniveau besteht und wir vorliegend auch keine
             geeigneten Garantien für den Schutz Ihrer Daten erbringen können,
             um dieses Defizit auszugleichen.
             </p>

             <p>
                <strong>Mögliche Risiken</strong> der Datenübermittlung in
                die USA für Sie sind insbesondere, dass ein
                <strong>Zugriff staatlicher Stellen</strong>
                nicht ausgeschlossen werden kann und Ihre Daten, möglicherweise
                ohne dass Sie darüber gesondert informiert werden und
                ohne dass Ihnen durchsetzbare Rechte und wirksame Rechtsbehelfe
                zur Verfügung stehen, aus Gründen der nationalen Sicherheit,
                der Strafverfolgung oder für andere im öffentlichen Interesse
                der USA liegende Zwecke verarbeitet werden könnten.
             </p>
             `,
    },
    alwaysAccept: {
        de: "Google Maps immer akzeptieren",
        en: "Always accept Google Maps",
    },
    accept: {
        de: "Akzeptieren",
        en: "Accept",
    },
};
const MapConsent = ({ enableMapsGlobally, setThisMapIsEnabled, venue, currentLocale, }) => {
    const [isChecked, setIsChecked] = (0, react_1.useState)(false);
    const [userScrolledToBottom, setUserScrolledToBottom] = (0, react_1.useState)(false);
    const handleScroll = (evt) => {
        if (Math.ceil(evt.target.scrollHeight - evt.target.scrollTop) ===
            evt.target.clientHeight) {
            setUserScrolledToBottom(true);
        }
    };
    (0, react_1.useEffect)(() => {
        const scrollArea = document.querySelector(".bulk-text");
        if (scrollArea) {
            handleScroll({ target: scrollArea });
            scrollArea.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (scrollArea) {
                scrollArea.addEventListener("scroll", handleScroll);
            }
        };
    }, []);
    const showPrivacyStatement = () => {
        window.open(venue.privacyStatementUrl, "_blank");
    };
    /* eslint-disable jsx-a11y/anchor-is-valid */
    return (react_1.default.createElement(MapConsentWrapper, null,
        react_1.default.createElement("div", { className: "content" },
            react_1.default.createElement("h3", null, miniDictionary.title[currentLocale]),
            react_1.default.createElement("div", { className: "bulk-text" },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                        __html: miniDictionary.disclaimerText[currentLocale],
                    } }),
                currentLocale === "de" ? (react_1.default.createElement("p", null,
                    "Erteilte Einwilligungen k\u00F6nnen Sie jederzeit mit Wirkung f\u00FCr die Zukunft \u00FCber die",
                    " ",
                    react_1.default.createElement("a", { target: "blank", href: "", onClick: (evt) => {
                            evt.preventDefault();
                            if (window.usercentrics) {
                                window.usercentrics.showSettings();
                            }
                        } }, "Einstellungen"),
                    " ",
                    "widerrufen. Weitere Informationen erhalten Sie in unserer",
                    " ",
                    react_1.default.createElement("a", { href: "", onClick: (evt) => {
                            evt.preventDefault();
                            showPrivacyStatement();
                        } }, "Datenschutzerkl\u00E4rung"),
                    " ",
                    "sowie in der",
                    " ",
                    react_1.default.createElement("a", { target: "blank", href: "https://policies.google.com/privacy" }, "Datenschutzerkl\u00E4rung von Google"),
                    ".")) : (react_1.default.createElement("p", null,
                    "You can withdraw consent that you have given at any time with future effect via the",
                    " ",
                    react_1.default.createElement("a", { target: "blank", href: "", onClick: (evt) => {
                            evt.preventDefault();
                            if (window.usercentrics) {
                                window.usercentrics.showSettings();
                            }
                        } }, "settings"),
                    ". For further information, please see our",
                    " ",
                    react_1.default.createElement("a", { href: "", onClick: (evt) => {
                            evt.preventDefault();
                            showPrivacyStatement();
                        } }, "Data Protection Declaration"),
                    " ",
                    "and Google\u2018s",
                    " ",
                    react_1.default.createElement("a", { target: "blank", href: "https://policies.google.com/privacy" }, "Privacy Policy"),
                    ".")),
                react_1.default.createElement("p", { className: "small-text" }, "*Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland; Mutterunternehmen: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA")),
            react_1.default.createElement(material_1.Button, { onClick: () => {
                    if (isChecked) {
                        enableMapsGlobally();
                    }
                    else {
                        setThisMapIsEnabled();
                    }
                }, disabled: !userScrolledToBottom, variant: "contained", size: "large", fullWidth: true }, miniDictionary.accept[currentLocale]),
            react_1.default.createElement("div", { className: "checkbox-wrapper" },
                react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Checkbox_1.default, { checked: isChecked, onChange: () => {
                            setIsChecked(!isChecked);
                        } }), label: miniDictionary.alwaysAccept[currentLocale] })))));
};
const mapStoreToProps = (store) => ({
    venue: store.getValue("venue"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(MapConsent);
